export const LOGO_URL = "/igc-logo-icon.png";
export const SUPPORT_EMAIL = "support@igchq.com";
export const PORTAL_NAME = "Iron Gate Private Portal";
export const PORTAL_SUBTITLE = "Private Client Access";
export const ECOMMERCE_MODULE_NAME = "Ecommerce Client Portal";

export function getPortalTitleForRole(role) {
  if (role === "client") return "Iron Gate Private Portal";
  if (role === "backoffice") return "IGC Back Office";
  if (role === "manager") return "IGC Manager Portal";
  return PORTAL_NAME;
}
